import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { RolesEnum } from '@irembo-andela/irembogov3-common';
import { IServiceChangeRequest } from '../../../../core/models/service-change-request.model';
import { UserCanReviewServiceChangeRequests } from '../../../../core/config/service-change-request.config';

@Component({
  selector: 'irembogov-service-change-request-reviewer-action-widget',
  templateUrl: './service-change-request-reviewer-action-widget.component.html',
})
export class ServiceChangeRequestReviewerActionWidgetComponent
  implements OnInit, OnDestroy
{
  @Input() changeRequest!: IServiceChangeRequest;
  @Input() isProcessing = false;
  userActiveRole!: RolesEnum;
  private userActiveRole$ = new Subject<void>();

  @Output() OnReviewClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.userActiveRole$.subscribe(newRole => {
      if (newRole === 'UNKNOWN_ROLE') {
        this.initializeRoles();
      } else {
        this.userActiveRole = newRole;
      }
    });
  }

  checkIfCanReviewChangeRequests() {
    if (!this.userActiveRole) return false;
    return UserCanReviewServiceChangeRequests.indexOf(this.userActiveRole) > -1;
  }

  ngOnDestroy(): void {
    this.userActiveRole$.next();
    this.userActiveRole$.complete();
  }

  // Get the first allowed role in the array and make it active role.
  async initializeRoles() {
    // Fetch and handle roles in ngOnInit
    const firstAllowedRole = await this.authService.firstAllowedRole();

    if (firstAllowedRole) {
      this.userActiveRole = firstAllowedRole;
    }
  }
}
